<template>
    <v-dialog v-model="dialog" persistent width="400">
        <v-card>
            <v-card-text class="pt-2">
                <div class="red lighten-5 mx-auto qj-icon-archive">
                    <v-icon x-large color="red">mdi-archive-arrow-down-outline</v-icon>
                </div>
                <h2 class="font-weight-regular text-xs-center red--text text--lighten-1" v-html="textStatus">
                </h2>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-btn dark block large depressed class="ma-0 qj-br-0" color="grey lighten-1"
                    @click="$emit('update:dialog', false)">
                    Não
                </v-btn>
                <v-btn dark block large depressed class="ma-0 qj-br-0" color="red lighten-1" @click="archiveStimulus()">
                    Sim
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ["dialog", "active", "isMultiple"],
    computed: {
        textStatus() {
            switch (this.active) {
                case true:
                    return "Deseja arquivar esse estimulo?";
                case false:
                    return "Deseja desarquivar esse estimulo?";
                default:
                    return "Deseja alterar o estado desses estímulos?";
            }
        },
    },
    methods: {
        archiveStimulus() {
            this.$emit('update:dialog', false)
            if(this.isMultiple){this.$emit("archiveMultiStimulus");}
            else{this.$emit("archiveStimulus")};
        },
    },
};
</script>

<style>
.qj-icon-archive {
    width: 70px;
    border-radius: 50%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.qj-br-0 {
    border-radius: 0 !important;
}
</style>
